import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-info-circle",
  "use": "icon-cl-info-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-cl-info-circle\"><path d=\"M12 1.5C6.213 1.5 1.5 6.213 1.5 12S6.213 22.5 12 22.5 22.5 17.787 22.5 12 17.787 1.5 12 1.5Z\" fill=\"#262626\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-.5 1.5a1 1 0 0 0-1 1V17a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-5.5a1 1 0 0 0-1-1h-1Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol